import { queryKey } from '@features/operations/api/useAllPlans'
import { locutusCreatePlanApi } from 'api-validations/locutus'
import { useOrgCodeOrThrow } from 'shared-ui/active-operation'
import { queryClient, useApiClient, useMutation } from 'shared-ui/api-provider'
import type { z } from 'zod'

/**
 * Mutation for creating a plan for a field
 */
export const useCreatePlan = () => {
  const orgCode = useOrgCodeOrThrow()
  const apiClient = useApiClient()

  return useMutation({
    mutationFn: async ({
      fieldId,
      ...body
    }: z.infer<typeof locutusCreatePlanApi.requestBodySchema> & { fieldId: string }) => {
      const response = await apiClient.post(locutusCreatePlanApi.pathFor({ orgCode, fieldId }), {
        body
      })

      return locutusCreatePlanApi.responseSchema.parse(response.body)
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [queryKey, orgCode] })
      queryClient.invalidateQueries({ queryKey: [orgCode, 'field-plans'] })
    }
  })
}
